import { Component, Inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-change-account-error-modal',
  templateUrl: './change-account-error-modal.component.html',
  styleUrls: ['./change-account-error-modal.component.scss'],
})
export class ChangeAccountErrorModalComponent {
  formGroup: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangeAccountErrorModalComponent>,
    private fb: FormBuilder,
    private message: MessageService,
    private api: BusApiService,
    private router: Router
  ) {
    this.formGroup = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      backup_code_one: ['', []],
      backup_code_two: ['', []],
    });
  }

  loading = false;
  close(r: any = null) {
    this.dialogRef.close(r);
  }

  async onOk() {
    if (!this.formGroup.value.username) {
      this.message.warn('请正确填写邮箱', { position: 'top' });
      return;
    }
    if (!this.formGroup.value.password) {
      this.message.warn('请填写密码', { position: 'top' });
      return;
    }
    if (
      this.data.bus.bus_type.backup_code_one === 'Required' &&
      !this.formGroup.value.backup_code_one
    ) {
      this.message.warn('请填写您的备用安全码1', { position: 'top' });
      return;
    } else if (
      this.data.bus.bus_type.backup_code_two === 'Required' &&
      !this.formGroup.value.backup_code_two
    ) {
      this.message.warn('请填写您的备用安全码2', { position: 'top' });
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.changeAccountError(
        this.data.id,
        this.formGroup.value.username,
        this.formGroup.value.password,
        this.formGroup.value.backup_code_one,
        this.formGroup.value.backup_code_two
      );
      if (r.status === 0) {
        this.message.open('提交成功');
        this.dialogRef.close();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
